// Formatação numérica em pt-BR.
//
// As telas formatavam à mão, com `valor.toFixed(2)` e às vezes um
// `.replace('.', ',')` em seguida. O resultado era inconsistente: onde faltava o
// replace saía "2300.00" (padrão americano) e, mesmo onde havia, saía "2300,00"
// — sem separador de milhar. O backend já devolve o formato certo nas
// propriedades *Display; isto cobre o que é calculado no cliente.
//
// Intl.NumberFormat é nativo e não exige biblioteca nova.

const MOEDA = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

const NUMERO = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

function paraNumero(valor) {
  const n = Number(valor);

  // Soma sobre lista vazia, campo ainda não preenchido, null vindo da API:
  // exibir "R$ 0,00" é melhor do que "NaN" na tela.
  return Number.isFinite(n) ? n : 0;
}

/** 2300.5 -> "R$ 2.300,50" */
export function moeda(valor) {
  return MOEDA.format(paraNumero(valor));
}

/** 2300.5 -> "2.300,50" (sem símbolo, para onde o template já escreve "R$") */
export function numero(valor) {
  return NUMERO.format(paraNumero(valor));
}
